<div>
    <table mat-table [dataSource]="dataSource" style="border-radius: 10px; margin-bottom: 1rem;" class="mat-elevation-z8">
        <ng-container matColumnDef="documentName">
            <th mat-header-cell *matHeaderCellDef>
                Nombre
            </th>
            <td mat-cell *matCellDef="let element">
                <span>{{element.documentName}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="documentDescription">
            <th mat-header-cell *matHeaderCellDef>
                Descripción
            </th>
            <td mat-cell *matCellDef="let element">
                <span>{{element.documentDescription}}</span>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"
        [cdkContextMenuTriggerFor]="menu">
            <ng-template #menu>
                <div cdkMenu class="met-elevation-z0">
                    <ul>
                        <li>
                            <button style="background-color: orange;" (click)="clickUpdateDocumentType(row)" mat-raised-button class="context-menu-item">
                                Modificar
                            </button>
                        </li>
                    </ul>
                </div>
            </ng-template>
        </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
</div>